// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3Rb0t","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2VRRi","obliqueLine":"membershipbadge_obliqueLine__34W-O"};